// @ts-check
import 'Styles/commonComponents/settings/settingsBlockItem.scss';
import { observer } from "mobx-react";
import React from 'react';

/**
 * @param {{
* className?: string,
* children: React.JSX.Element | React.JSX.Element[]
* }} props 
* @returns {React.JSX.Element}
*/
const SettingsBlockItem = (props) =>
    <div className={'settings-block-item ' + (props.className ? props.className : '')}>
        {props.children}
    </div>

export default observer(SettingsBlockItem);